import React from "react";
import { Environment } from "../../../../../service/globalTypes";
import { CONFIG, LocalStorageKeys, SentryCustomData } from "../../../../../config";
import { capitalizeFirstLetter } from "../../../../../utils/capitalizeFirstLetter";
import { Caption1, Dropdown, Field, Option } from "@fluentui/react-components";
import { useAppDispatch } from "../../../../../store";
import { setEnvironment } from "../../../store";
import * as Sentry from "@sentry/react";

const ENVIRONMENTS_OPTIONS_PROD = [Environment.PRODUCTION, Environment.DEMO];
const ENVIRONMENTS_OPTIONS_NOT_PROD = [...ENVIRONMENTS_OPTIONS_PROD, Environment.STAGING, Environment.DEVELOPMENT, Environment.QA];
const ENVIRONMENTS_OPTIONS =
  CONFIG.BUILD_ENVIRONMENT === Environment.PRODUCTION ? ENVIRONMENTS_OPTIONS_PROD : ENVIRONMENTS_OPTIONS_NOT_PROD;

interface DropdownEnvironmentOptionsProps {
  isConnectionEstablished: boolean;
}

function DropdownEnvironmentOptions({ isConnectionEstablished }: Readonly<DropdownEnvironmentOptionsProps>) {
  const dispatch = useAppDispatch();

  const handleSelectEnvironment = (env: Environment) => {
    dispatch(setEnvironment(env));
    localStorage.setItem(LocalStorageKeys.ENVIRONMENT, env);

    Sentry.setExtra(SentryCustomData.ENVIRONMENT, env);
  };

  return (
    <Field label={<Caption1>Select environment.</Caption1>}>
      <Dropdown defaultValue={capitalizeFirstLetter(Environment.PRODUCTION)} disabled={isConnectionEstablished}>
        {ENVIRONMENTS_OPTIONS.map((env) => (
          <Option key={env} onClick={() => handleSelectEnvironment(env)} value={env}>
            {capitalizeFirstLetter(env)}
          </Option>
        ))}
      </Dropdown>
    </Field>
  );
}

export default DropdownEnvironmentOptions;
